import React, { useEffect } from "react";
import { motion } from "framer-motion";

/**
 * Modern card section for organized-tour profile.
 */
export default function OrganizedTourProfileSection({
  id,
  title,
  icon: Icon,
  children,
  className = "",
}) {
  useEffect(() => {
    if (!import.meta.env?.DEV || !id) return;
    console.log("[ORG_TOUR_PROFILE_SECTION_RENDER]", { id, title });
  }, [id, title]);

  return (
    <motion.section
      id={id}
      className={`otp-section ${className}`.trim()}
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.35, ease: "easeOut" }}
    >
      <header className="otp-section__header">
        {Icon ? (
          <span className="otp-section__icon" aria-hidden>
            <Icon />
          </span>
        ) : null}
        <h2 className="otp-section__title">{title}</h2>
      </header>
      <div className="otp-section__body">{children}</div>
    </motion.section>
  );
}
